// Step 3
// Payment Details Step
import { useState, useEffect } from "react";
import Product from "../product-component/product";
import Payment from "../payment-component/payment";

import americanExpress from "../../assets/images/payment-american-express.png";
import mastercard from "../../assets/images/payment-mastercard.png";
import visa from "../../assets/images/payment-visa.png";
import StepsIndicator from "../steps-indicator";
import BackButton from "../UI/back-button";
import Layout from "../layout";
import ErrorBoundary from "../errors/ErrorBoundary";
import ReviewCard from "./review-card";

export default function PaymentStep({
  language,
  selectMembership,
  isRenewalPage,
  businessCategories,
  currentStep,
  languages,
  locationData,
  stepNo,
  localStorageDatas,
  goNextStep,
  couponObj,
  isUserLogged,
  subsidiary,
  goPreviousStep,
}) {
  //const [paymentOption, setPaymentOption] = useState('option1')

  function handleChange(e) {
    //setPaymentOption(e.target.value)
  }

  const [isPaymentScreen, setIsPaymentScreen] = useState(false);
  const [isDirectLink, setIsDirectLink] = useState(false);
  const [paymentName, setPaymentName] = useState("");

  const loadPaymentMethodStep = (method, directLink) => {
    console.log("method", method);
    setPaymentName(method);
    setIsDirectLink(directLink);
    setIsPaymentScreen(true);
  };

  const goBacktoPaymentMethod = () => {
    setIsPaymentScreen(false);
  };

  console.log("step", stepNo);

  if (currentStep !== stepNo) {
    return null;
  }
  let item_selected = localStorageDatas.members?.[0].selected_product;
  const membershipItem = Object.values(item_selected)[0].item_group_description;
  // if(item_selected){
  //   const membershipItem = Object.values(item_selected)[0].item_group_description
  //   setMembershipItem(membershipItem)
  // }
  return (
    <Layout>
      <ErrorBoundary membershipItem={membershipItem}>
        {/* <BackButton goPreviousStep={goPreviousStep}/> */}
        {/* <StepsIndicator step={currentStep} stepText={"Payment"} subTitleHeader={"Pay your Accor Plus Explorer Membership"}/> */}

        <div className="grid grid-cols-1 tablet:grid-cols-2 tablet:gap-4">
          {/* Left Column: CardAsset */}
          <div className="flex flex-col mx-auto xs:mx-0">
            {isPaymentScreen ? (
              <BackButton goPreviousStep={goBacktoPaymentMethod} />
            ) : (
              <BackButton goPreviousStep={goPreviousStep} />
            )}
            <div className="xs:hidden">
              <ReviewCard
                languages={languages}
                locationData={locationData}
                localStorageDatas={localStorageDatas}
                isRenewalPage={false}
                isExpress={false}
                isUserLogged={isUserLogged}
                businessCategories={businessCategories}
                couponObj={couponObj}
              />
            </div>
          </div>

          {/* Right Column: Form */}
          <div className="xs:flex xs:justify-center xs:flex-col w-[420px] xs:w-auto">
            <div className="holder-title">
              <StepsIndicator
                step={currentStep}
                stepText={
                  languages && languages.stepTitle4
                    ? languages.stepTitle4
                    : "Payment"
                }
                subTitleHeader={
                  languages && languages.payYourMembership
                    ? languages.payYourMembership
                    : "Pay for your membership"
                }
                languages={languages}
              />
            </div>
            <Payment
              selectMembership={selectMembership}
              locationData={locationData}
              localStorageDatas={localStorageDatas}
              goNextStep={goNextStep}
              couponObj={couponObj}
              isUserLogged={isUserLogged}
              businessCategories={businessCategories}
              isRenewalPage={isRenewalPage}
              languages={languages}
              subsidiary={subsidiary}
              currentStep={currentStep}
              goPreviousStep={goPreviousStep}
              loadPaymentMethodStep={loadPaymentMethodStep}
              paymentName={paymentName}
              goBacktoPaymentMethod={goBacktoPaymentMethod}
              isPaymentScreen={isPaymentScreen}
              isDirectLink={isDirectLink}
            />
          </div>
        </div>
      </ErrorBoundary>
      {/* <ErrorBoundary membershipItem={membershipItem}>
        <BackButton goPreviousStep={goPreviousStep}/>
        <StepsIndicator step={currentStep} stepText={"Payment"} subTitleHeader={`Pay your ${membershipItem}`}/>
          <Payment 
            selectMembership   = {selectMembership} 
            locationData       = {locationData} 
            localStorageDatas  = {localStorageDatas} 
            goNextStep         = {goNextStep} 
            couponObj          = {couponObj}
            isUserLogged       = {isUserLogged}
            businessCategories = {businessCategories}
            isRenewalPage      = {isRenewalPage}
            languages          = {languages}
            subsidiary         = {subsidiary}
          />
        </ErrorBoundary> */}
    </Layout>
  );
}
